import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { hasRouteAccess } from '../../config/routes';

const RouteGuard = ({ children, allowedTypes = [], requiredPermissions = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Загрузка...
      </div>
    );
  }

  // Если пользователь не авторизован
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если тип профиля отсутствует у авторизованного пользователя
  if (!user.profile_type_code) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если список разрешенных типов пуст - разрешаем доступ (при отсутствии проверки permission)
  if (allowedTypes.length === 0 && requiredPermissions.length === 0) {
    return children;
  }

  if (requiredPermissions.length > 0) {
    const codes = user.permission_codes || [];
    const ok = requiredPermissions.every((p) => codes.includes(p));
    if (!ok) {
      return <Navigate to="/403" state={{ from: location }} replace />;
    }
  }

  // Проверяем доступ по типу профиля
  // Специальная проверка для пользователя customer, пытающегося получить доступ к своему профилю
  const profilePathMatch = location.pathname.match(/^\/profiles\/([^/]+)\/?$/);
  const requestedProfileUid = profilePathMatch?.[1];
  if (
    user.profile_type_code === 'customer' &&
    requestedProfileUid &&
    requestedProfileUid === user.profile_uid
  ) {
    // Разрешаем customer только просмотр собственного профиля (без edit/complete и других подмаршрутов)
    return children;
  }
  
  // Стандартная проверка прав доступа
  if (allowedTypes.length > 0 && !hasRouteAccess(location.pathname, user.profile_type_code)) {
    return <Navigate to="/403" state={{ from: location }} replace />;
  }

  return children;
};

export default RouteGuard; 